





import {
  apiV1AdminKnowHowPath,
  apiV1AdminKnowHowsPath,
} from '@/rails/routes'
import {Component} from 'vue-property-decorator'
import PostForm from '@/components/admin/PostForm.vue'
import PostNew from '@/components/admin/PostNew'
import {BreadCrumb} from '@/pages/page-base'

@Component({
  components: {
    PostForm
  }
})
export default class KnowHowsNew extends PostNew {
  path = 'know_hows'
  createPath = apiV1AdminKnowHowsPath()

  async mounted(): Promise<void> {
    this.targetPath = apiV1AdminKnowHowPath('new')
    return super.mounted()
  }

  get breadcrumbs(): Array<BreadCrumb> {
    return [
      {
        text: '転職ノウハウ',
        to: '/admin/know_hows',
        exact: true
      },
      {
        text: '転職ノウハウ新規作成'
      }
    ]
  }
}
